.wrap {
  padding: 90px 30px 0;
  text-align: center;
}
.divider {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 9px;
}
.dividerBottom {
  gap: 14px;
  margin-top: 36px;
}
.line {
  height: 1px;
  background-color: var(--rule);
}
.lineShort {
  width: 38px;
}
.lineLong {
  width: 46px;
}
.dot {
  display: inline-block;
  border-radius: 50%;
  background: radial-gradient(circle at 32% 28%, #ffffff 0%, #f5ede2 38%, #e0d4c1 70%, #cdbda4 100%);
}
.dotSmall {
  width: 6px;
  height: 6px;
  box-shadow: 0 1px 3px rgba(120, 100, 70, 0.3);
}
.dotMid {
  width: 11px;
  height: 11px;
  box-shadow: 0 2px 5px rgba(120, 100, 70, 0.3);
}
.dotLarge {
  width: 10px;
  height: 10px;
  box-shadow: 0 2px 5px rgba(120, 100, 70, 0.3);
}
.title {
  margin: 18px 0 0;
  font-family: var(--font-script);
  font-weight: 400;
  font-size: 40px;
  letter-spacing: 1px;
  color: var(--pink);
}
.greeting {
  margin: 26px 0 0;
  font-size: 17px;
  line-height: 2.15;
  color: var(--ink-3);
  text-wrap: pretty;
}
